export default __webpack_public_path__ + "static/media/belay.cde7e970.jpg";